export const BENEFIT_FEATURE_SWITCH = 'benefits';
export const DUAL_PRICE_ORDER_FEATURE_SWITCH = 'IsPrimaryCurrencyFirst';
export const ENABLE_LOWER_ZOOM = 'EnableLowerZoom';
export const ENABLE_LOYALTY = 'EnableLoyalty';
export const THANK_YOU = 'thankyou';
export const GOOGLE_RETAIL_API_USER_EVENTS = 'googleRetailApiUserEvents';
export const UPSELLING_REDESIGN_V2 = 'UpsellingRedesignV2';
export const DELIVERY_AND_PAYMENT_FEATURE_SWITCH = 'deliveryAndPayment';
export const ENABLE_STICKY_BUTTONS_CART = 'EnableStickyButtonsOnCart';
export const ENABLE_STICKY_BUTTONS_DAP = 'EnableStickyButtonsOnDap';
export const ENABLE_STICKY_BUTTONS_UPSELLING = 'EnableStickyButtonsOnUpselling';
export const ENABLE_ADYEN_V6 = 'EnableAdyenV6';
export const DISABLE_SALE_PRICE = 'DisableSalePrice';
export const ENABLE_PRZELEWY_PAYPO_NEW_FLOW_OALT = 'EnablePrzelewy24PaypoNewFlowOalt';
export const ENABLE_PLUSMINUS_BUTTONS_CART = 'EnablePlusMinusButtonsOnCart';
